import { useOutletContext } from "react-router-dom"
import { withAiContext } from "connected-components/ai-teammate/hocs/with-ai-context"

export function createDateAdapter(useDates) {
  return function withDates(Component) {
    return withAiContext(() => {
      const { modelId, selectedBase, isActive, portfolioUUID } = useOutletContext()
      const { startDate, endDate } = useDates()

      return {
        modelId,
        instrument: { type: "PORTFOLIO", id: portfolioUUID },
        base: isActive ? selectedBase : undefined,
        startDate,
        endDate,
        isPreferencesLoaded: Boolean(modelId && portfolioUUID),
        nudgeScopeKey: "portfolio",
      }
    })(Component)
  }
}
